import controllerDataConfigApi from '@/api/config/controllerDataConfig'
import { queryKeys } from '@/constant/common'
import { useQuery } from '@tanstack/react-query'

function useSearchControllerId(
  interfaceId: number,
  id?: string,
) {
  return useQuery(
    [[queryKeys.controller], interfaceId,  id],
    async () => {
      if (!interfaceId || !id) return null
      const { data } = await controllerDataConfigApi.getById(
        interfaceId.toString(),
        id,
      )
      if (!data) return null

      return data
    },
  )
}

export default useSearchControllerId
